module.exports = __webpack_public_path__ + "img/product_101.e72ee78.webp";